import React from 'react'
import { kebabCase } from 'lodash-es'

export interface IFieldProps {
  className?: string
  label?: string
  required?: boolean
  disabled?: boolean
  hideDetails?: boolean
  helpText?: string
  hasError?: boolean
  errorText?: string
}

interface IProps extends IFieldProps {
  render: () => React.ReactElement | string
}

function Field(props: IProps): React.ReactElement {
  const modifiers = React.useMemo(() => {
    const ITEMS: string[] = ['disabled', 'hideDetails', 'hasError']

    return ITEMS.reduce((acc: string, item: string) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      if (props[item]) {
        acc += ` _${kebabCase(item)}`
      }

      return acc
    }, '')
  }, [props])

  return (
    <div className={`field ${props.className ?? ''} ${modifiers}`.trim()}>
      {props.label && (
        <div className={'field__label'}>
          {props.label}
          {props.required && <sup>*</sup>}
        </div>
      )}
      <div className="field__inner">
        {props.render()}
        {!props.hideDetails && (
          <div className="field__details">
            {props.helpText && (
              <p className="field__help-text">{props.helpText}</p>
            )}
            {props.hasError && (
              <p className="field__error-text">{props.errorText}</p>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default Field
